import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react-text';
import { Button } from '@paypalcorp/pp-react-buttons';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { redirectFlowAction } from '../../../framework/store/RedirectFlow/RedirectFlowActions';
import { REDIRECT_SUFFIX } from '../../config/pageNames';
import { CaptionText } from './components/CaptionText';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';

import './OlderVersionAppPage.less';

const LOCALE_PREFIX = 'US/pages/AppPendPage/OlderVersionAppPage';

export const OlderVersionAppPage = ({ doneRedirect, initialRender }) => {

    React.useEffect(() => {
        initialRender();
    }, []);

    const handleClick = () => {
        doneRedirect(REDIRECT_SUFFIX.CANCEL_REDIRECT);
    };

    return (
        <div className="olderVersionAppContainer">
            <HeadingText className="olderVersionAppHeading" size="md">
                <FormattedMessage id={`${LOCALE_PREFIX}.header`} />
            </HeadingText>    
            <>
                <CaptionText className="olderVersionAppSubtext olderVersionAppCaptionText" text={`${LOCALE_PREFIX}.olderVersionApp.captionText1`} />    
                <CaptionText className="olderVersionAppSubtext olderVersionAppCaptionText" text={`${LOCALE_PREFIX}.olderVersionApp.captionText2`} />
            </> 
            <Button onClick={handleClick} className="olderVersionAppActionButton">
                <FormattedMessage id={`${LOCALE_PREFIX}.btnText`} />
            </Button>
        </div>
    );
};

OlderVersionAppPage.propTypes = {
    doneRedirect: PropTypes.func.isRequired,
    initialRender: PropTypes.func.isRequired
};

export const mapDispatchToProps = dispatch => ({
    initialRender() {
        dispatch(trackTransition('apply_pp_credit_olderVersionAppPage', 'prepare_pp_credit_olderVersionAppPage'));
    },
    doneRedirect(actionUri) {
        dispatch(trackTransition('apply_pp_credit_olderVersionAppPage', 'process_pp_credit_olderVersionAppPage'));
        dispatch(spinnerOpen());
        dispatch(redirectFlowAction(actionUri));
    }
});

export default connect(null, mapDispatchToProps)(OlderVersionAppPage);
